import ScrollReveal from '@/components/base/ScrollReveal';

const trustItems = [
  {
    icon: 'ri-calendar-check-line',
    value: '6',
    statLabel: 'Años',
    label: 'Experiencia comprobada',
    description: 'Años impulsando el crecimiento financiero en México con resultados que nos respaldan.',
  },
  {
    icon: 'ri-government-line',
    value: 'SOFOM AUTORIZADA',
    statLabel: '',
    label: 'Registro oficial',
    description: 'Operamos con registro de la CNBV y CONDUSEF',
  },
  {
    icon: 'ri-eye-line',
    value: '100%',
    statLabel: '',
    label: 'Transparencia total',
    description: 'Sin letras pequeñas, sin cargos ocultos, sin sorpresas. Lo que ves en tu contrato es exactamente lo que pagas.',
  },
  {
    icon: 'ri-user-heart-line',
    value: '1a1',
    statLabel: '',
    label: 'Atención personalizada',
    description: 'Un asesor real, dedicado exclusivamente a tu caso, te acompaña desde el primer contacto hasta el depósito.',
  },
];

export default function TrustBanner() {
  return (
    <section
      id="confianza"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{ background: 'oklch(var(--background-50))' }}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent 0%, oklch(var(--accent-500) / 0.25) 25%, oklch(var(--accent-500) / 0.4) 50%, oklch(var(--accent-500) / 0.25) 75%, transparent 100%)' }}></div>

        <div className="absolute top-[-15%] right-[-5%] w-[500px] h-[500px] rounded-full opacity-[0.08]" style={{ background: 'radial-gradient(circle, oklch(var(--accent-500)) 0%, transparent 60%)' }}></div>
        <div className="absolute bottom-[-20%] left-[-8%] w-[600px] h-[600px] rounded-full opacity-[0.05]" style={{ background: 'radial-gradient(circle, oklch(var(--accent-400)) 0%, transparent 60%)' }}></div>

        <div className="absolute top-1/2 left-0 -translate-y-1/2 w-full h-40 opacity-[0.04]" style={{
          backgroundImage: 'radial-gradient(circle, oklch(var(--accent-500)) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
        <ScrollReveal animation="fade-up" duration={600}>
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 mb-4">
              <span className="w-8 h-px rounded-full bg-accent-500/40"></span>
              <span className="text-accent-600 text-sm font-semibold tracking-widest uppercase">¿Por qué elegirnos?</span>
              <span className="w-8 h-px rounded-full bg-accent-500/40"></span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              Construimos{' '}
              <span className="relative">
                <span className="relative z-10 bg-gradient-to-r from-accent-600 to-accent-500 bg-clip-text text-transparent">
                  confianza
                </span>
                <span className="absolute -bottom-1 left-0 w-full h-3 rounded-full -z-0 opacity-25" style={{ background: 'oklch(var(--accent-500))', filter: 'blur(6px)' }}></span>
              </span>
              {' '}con hechos, no con palabras
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {trustItems.map((item, index) => (
            <ScrollReveal key={item.label} animation="fade-up" delay={index * 130} duration={700}>
              <div
                className="relative group p-8 rounded-3xl transition-all duration-500 hover:scale-[1.03] h-full overflow-hidden"
                style={{
                  background: 'oklch(var(--background-50))',
                  border: '1px solid oklch(var(--background-200))',
                }}
              >
                <div className="absolute top-0 left-0 right-0 h-px opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'linear-gradient(90deg, transparent 0%, oklch(var(--accent-500) / 0.4) 50%, transparent 100%)' }}></div>

                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{ background: 'radial-gradient(ellipse at 50% 0%, oklch(var(--accent-500) / 0.05) 0%, transparent 60%)' }}
                ></div>

                <div className="relative z-10 flex flex-col h-full">
                  <div className="flex items-start gap-4 mb-5">
                    <div
                      className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0 transition-all duration-500 group-hover:scale-110 group-hover:rotate-6"
                      style={{ background: 'oklch(var(--accent-500) / 0.10)' }}
                    >
                      <i className={`${item.icon} text-2xl text-accent-600`}></i>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-accent-600 text-2xl md:text-3xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
                        {item.value}
                      </span>
                      {item.statLabel && (
                        <span className="text-foreground-400 text-xs font-medium -mt-1">{item.statLabel}</span>
                      )}
                    </div>
                  </div>

                  <h3 className="text-foreground-900 text-base font-semibold mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                    {item.label}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed flex-1">
                    {item.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}